var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 947.788,
    height: 708,
    viewBox: "0 0 947.788 708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a4d6;opacity:0.038;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(147 -42)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M854.134,655.475S712.64,782.15,565.357,642.055c-163.366-155.394-73.675-429.832-210.6-437.572S169.135,233.75,81.523,179.021C-20.188,115.485,2.061,0,2.061,0H854.134Z",
    transform: "translate(707.137 750) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M947.788,259.99s-59.929,67.842-151.646,44.44c-137.921-35.192-100.4-152.568-202.116-176.584s-392.016,26.841-490.7,0S0,0,0,0H947.784Z",
    transform: "translate(800.788 750) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth_background.496bcabd323507ac042130a9cd9e7d0f.svg";
export { ForwardRef as ReactComponent };